@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';

/**
 * Wide full width landscape box
 */
.board {
  clear: both;
  overflow: auto;
  width: 100%;
  margin: 0;
  padding: 70px 15px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  &,
  label {
    color: #fff;
  }
  a:not(.btn),
  a.btn-link {
    text-decoration: underline;
    &.btn {
      text-decoration: none;
      text-shadow: none;
    }
    &,
    &:hover,
    &:focus,
    &:active {
      color: #fff;
    }
  }
  .navbar {
    a {
      text-decoration: none;
      text-shadow: none;
    }
  }
  h2 {
    color: #fff;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
    font-size: 55px;
    line-height: 55px;
    letter-spacing: -1px;
    margin: 0;
    padding: 0;
  }
  .board-highlight {
    display: inline-block;
    padding: 5px 15px;
    text-shadow: none;
    margin: 0;
    &.board-highlight-primary {
      background: rgba(
        red(@brand-primary),
        green(@brand-primary),
        blue(@brand-primary),
        0.9
      );
    }
    &.board-highlight-secondary {
      background: rgba(
        red(@brand-secondary),
        green(@brand-secondary),
        blue(@brand-secondary),
        0.9
      );
    }
    &.board-highlight-transparent {
      text-shadow: 0 1px 10px rgba(0, 0, 0, 1);
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -1px;
      text-transform: uppercase;
    }
  }

  &.board-primary {
    background-color: @brand-primary;
    .page-header {
      h1,
      h2 {
        background: @brand-primary;
      }
    }
  }

  // Add inset shadow
  &.board-inset {
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  }

  &.small-screen-bad-background {
    @media (max-width: @screen-sm-max) {
      background-image: none !important;
      box-shadow: none !important;
    }
  }

  .page-header {
    margin: 0;
    h1 {
      // .h1(); @TODO find out what happened to this, not defined anywhere
    }
    h2 {
      // .h2();  @TODO find out what happened to this, not defined anywhere
    }
    &:before {
      border-color: #fff;
    }
  }

  // Fix panels inside boards
  .panel {
    color: @text-color;
    text-shadow: none;
  }

  /**
   * Board images
   * Most of the images for .board are coming from core/trBoards directive. Check it out.
   * Keep just the most simplest stuff here.
   */
  &.board-error {
    // Photo by Mikael Korpela
    // @link https://creativecommons.org/licenses/by-nc-nd/4.0/
    background-image: url(~img/board/error.jpg);
  }
}

.board.container-fullscreen {
  max-width: none;
}
